import Search from '@components/Search';
import RootDataProvider from './contexts/RootData/RootDataProvider';
import GlobalDataProvider from './contexts/GlobalData/GlobalDataProvider';
import { LoadingProvider } from './contexts/Loading/LoadingProvider';
import SpecificationsProvider from '@context/Specification';
import ScreenProvider from './contexts/Screen/ScreenProvider';
import FilterInfoModalProvider from './contexts/FilterInfoModal';

function App() {
    return (
        <div className="App occasion">
            <RootDataProvider>
                <LoadingProvider>
                    <GlobalDataProvider>
                        <SpecificationsProvider>
                            <ScreenProvider>
                                <FilterInfoModalProvider>
                                    <Search />
                                </FilterInfoModalProvider>
                            </ScreenProvider>
                        </SpecificationsProvider>
                    </GlobalDataProvider>
                </LoadingProvider>
            </RootDataProvider>
        </div>
    );
}

export default App;
